export default class BasicAuthConfig {
    constructor(
        public Username: string = "",
        public Password: string = "",
        public AuthUrl: string = ""
    ) { }
}